module.exports = __webpack_public_path__ + "3af789375320a7799e46adba01af164a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icon-name.svg
// module id = 95
// module chunks = 0